import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import BankAccountForm from './forms/BankAccountForm';
import BankAccountList from './lists/BankAccountList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class BankAccountEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Bankszámlák"
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <BankAccountList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Bankszámla"
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                    ]}
                >
                    <BankAccountForm {...this.props} />
                </Editor>
        </Fragment>;
    }
}

export default createEditor({componentName: "BankAccount", WrappedComponent: BankAccountEditor});
